import table from './table.js'
import tableSelect from './table-select.js'
export default { table, tableSelect }
